module.exports = __webpack_public_path__ + "img/qfpay.e5bb00d1.png";